import React from "react";
import { Link } from "react-router-dom";

/**
 * Acknowledgement strip displayed beneath every credential capture surface
 * (login, registration, invite acceptance, password creation/reset).
 *
 * Keeps the legal acknowledgement adjacent to the action that triggers
 * acceptance, so the user can pivot to the long-form documents in one click.
 */
export default function AuthAcknowledgement({ testid = "auth-acknowledgement", action = "accessing or using" }) {
  return (
    <div
      className="mt-5 text-xs leading-relaxed text-center"
      style={{ color: "var(--fop-text-3)" }}
      data-testid={testid}
    >
      By {action} ForgedOps Plans, you acknowledge and agree to the{" "}
      <Link
        to="/legal/terms"
        className="underline underline-offset-2"
        style={{ color: "var(--fop-primary)" }}
        data-testid={`${testid}-terms-link`}
      >
        Terms of Use
      </Link>{" "}
      and{" "}
      <Link
        to="/legal/privacy"
        className="underline underline-offset-2"
        style={{ color: "var(--fop-primary)" }}
        data-testid={`${testid}-privacy-link`}
      >
        Privacy Policy
      </Link>
      .
    </div>
  );
}
